export default "__VITE_ASSET__CYFCa8hu__"